import React from "react";
import { Field } from "redux-form";
import * as normalizers from "common/normalizers";
import * as validations from "common/validations";
import FieldGroup from "components/FieldGroup";
import InputPack from "components/InputPack";

class HealthSupplementsTotals extends React.Component {
    render() {
        return (
            <div className="Grid-cell u-lg-width2of3">
                <h3>Total annual amounts</h3>
                <FieldGroup>
                    <Field name="mgOxide_kgYr" label="Magnesium oxide" placeholder="0" type="text" uom="kg/yr" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(0, 99999)]} component={InputPack} />
                    <Field name="mgSulphate_kgYr" label="Magnesium sulphate" placeholder="0" type="text" uom="kg/yr" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(0, 99999)]} component={InputPack} />
                    <Field name="mgChloride_kgYr" label="Magnesium chloride" placeholder="0" type="text" uom="kg/yr" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(0, 99999)]} component={InputPack} />
                </FieldGroup>
                <FieldGroup>
                    <Field name="salt_kgYr" label="Salt" placeholder="0" type="text" uom="kg/yr" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(0, 99999)]} component={InputPack} />
                    <Field name="limeFlour_kgYr" label="Lime flour" placeholder="0" type="text" uom="kg/yr" dataWidth="33" normalize={normalizers.integer} validate={[validations.range(0, 99999)]} component={InputPack} />
                </FieldGroup>
            </div>
        );
    }
}

export default HealthSupplementsTotals;
